import { useContext } from "react";
import { PanelContext } from "src/components/Panel/PanelContext.tsx";

export const usePanelContext = () => {
  return useContext(PanelContext);
};
